import { SHOW_MODAL, CLOSE_MODAL } from '../actions/actionTypes'

const initialState = {
    modal: null,
    size: 'md'
}

const modal = (state = initialState, action) => {
    switch(action.type){
        case SHOW_MODAL:
            return {
                ...state,
                modal: action.modal
            }
        case CLOSE_MODAL:
            return {
                ...state,
                modal: null
            }
        default:
            return state
    }
}

export default modal